export const validFieldsForm = (values) =>
  !(
    values.name === '' ||
    values.currency === '' ||
    values.street === '' ||
    values.city === '' ||
    values.postalCode === '' ||
    values.country === ''
  );
